module.exports = __webpack_public_path__ + "img/ranking-active.c16306a7.svg";